import Carousel from 'react-bootstrap/Carousel';
import './searchcard.css'
import React, { useState, useEffect, useContext } from "react";
import { Rating } from "@mui/material";
import { CartContext } from '../../wishlist/Wishlistcontext';
import { useNavigate, useParams } from "react-router-dom";
import { products } from './data'
import { link } from '../../../config';
import * as Wish from '../../../network/api/wish'
import { useTranslation } from 'react-i18next';

function SearchCard(props) {
  const navigate = useNavigate()
    const { t } = useTranslation();
  
  const addToWish = async (id) => {
    await Wish.addWish(id).then((e) => {
      props.update_p()
    })
  }

  const paragrapghstyle = {
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    display: '-webkit-box',

  }

  const [isOpen, setIsOpen] = useState(false);
  const { addToWishlist } = useContext(CartContext);



  return (
    <div className=' cardside' >

      {props.products?.map((product, index) => (
        <div className=" card-div border-0" key={product._id}>
          <div className="carousel-wrapper ">

            <Carousel controls={false}>

              {product.images.map((image) => (
                <Carousel.Item key={image.num}>
                  <img className="d-block  arousel-wrapper-imgs " src={`${link}${image}`} alt={image} ></img>
                </Carousel.Item>
              ))}

            </Carousel>
            <div className='card-div-req'>

              {props.personal?.wish?.includes(product._id) ? (
                <svg className='love' xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
                  <g filter="url(#filter0_d_3_2)">
                    <mask id="mask0_3_2" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="4" y="0" width="24" height="22">
                      <path d="M4 0H28V21.037H4V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_3_2)">
                      <mask id="mask1_3_2" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="4" y="-1" width="25" height="23">
                        <path d="M5.80681 3.87722L5.80668 3.87743C4.18039 6.56127 5.28615 9.18404 6.79297 10.6355L16.1667 19.6441L25.3106 10.6985C26.7229 9.11492 27.2068 7.52516 26.9218 5.76389L26.9218 5.76379C26.5231 3.29783 24.4892 1.37209 21.9677 1.09717C20.4103 0.929055 18.927 1.37006 17.7723 2.331C17.4599 2.59108 17.1815 2.881 16.9388 3.19597L16.1625 4.20369L15.3666 3.21131C15.0789 2.85264 14.7384 2.5211 14.3484 2.22393L5.80681 3.87722ZM5.80681 3.87722C6.70413 2.39556 8.10968 1.40029 9.63548 1.10459M5.80681 3.87722L9.63548 1.10459M9.63548 1.10459C11.279 0.788851 12.9961 1.1946 14.3481 2.22367L9.63548 1.10459Z" fill="white" stroke="white" stroke-width="2" />
                      </mask>
                      <g mask="url(#mask1_3_2)">
                        <path d="M4.95145 3.35919C3.00546 6.57061 4.3766 9.69639 6.09921 11.3557L16.1729 21.0371L26.0336 11.3901C27.6359 9.60534 28.2501 7.7122 27.909 5.60418C27.4376 2.68828 25.039 0.425938 22.0757 0.103021C20.2582 -0.0933522 18.5028 0.42208 17.1324 1.56251C16.7636 1.86961 16.4341 2.21259 16.1467 2.58566C15.806 2.16089 15.4063 1.77277 14.9542 1.42825C13.3785 0.228793 11.3727 -0.247673 9.44605 0.122697C7.6212 0.476092 5.98347 1.6551 4.95145 3.35919Z" fill="black" stroke="black" stroke-width="2" />
                      </g>
                    </g>
                  </g>
                  <defs>
                    <filter id="filter0_d_3_2" x="0" y="0" width="32" height="29.037" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_2" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_2" result="shape" />
                    </filter>
                  </defs>
                </svg>
              ) : (
                <svg className='love' style={{ cursor: "pointer" }} onClick={() => {
                  addToWish(product._id)
                }} xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
                  <mask id="mask0_80_787" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="22">
                    <path d="M0 0H24V21.037H0V0Z" fill="white" />
                  </mask>
                  <g mask="url(#mask0_80_787)">
                    <mask id="mask1_80_787" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="-1" width="25" height="23">
                      <path d="M1.80681 3.87721L1.80668 3.87743C0.180388 6.56127 1.28615 9.18404 2.79297 10.6355L12.1667 19.6441L21.3106 10.6985C22.7229 9.11491 23.2068 7.52516 22.9218 5.76389L22.9218 5.76379C22.5231 3.29783 20.4892 1.37209 17.9677 1.09717C16.4103 0.929051 14.927 1.37006 13.7723 2.33099C13.4599 2.59107 13.1815 2.88099 12.9388 3.19596L12.1625 4.20369L11.3666 3.2113C11.0789 2.85264 10.7384 2.52109 10.3484 2.22393L1.80681 3.87721ZM1.80681 3.87721C2.70413 2.39555 4.10968 1.40029 5.63548 1.10459M1.80681 3.87721L5.63548 1.10459M5.63548 1.10459C7.279 0.788847 8.99609 1.19459 10.3481 2.22367L5.63548 1.10459Z" stroke="white" stroke-width="2" />
                    </mask>
                    <g mask="url(#mask1_80_787)">
                      <path d="M0.951448 3.35919C-0.99454 6.57061 0.376602 9.69638 2.09921 11.3557L12.1729 21.037L22.0336 11.3901C23.6359 9.60533 24.2501 7.7122 23.909 5.60418C23.4376 2.68828 21.039 0.425934 18.0757 0.103017C16.2582 -0.093356 14.5028 0.422076 13.1324 1.56251C12.7636 1.86961 12.4341 2.21259 12.1467 2.58566C11.806 2.16089 11.4063 1.77277 10.9542 1.42825C9.37853 0.228789 7.37275 -0.247677 5.44605 0.122693C3.6212 0.476089 1.98347 1.6551 0.951448 3.35919Z" stroke="black" stroke-width="2" />
                    </g>
                  </g>
                </svg>
              )}

              <button className='ico-btn-div btn-cart'>
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="35" viewBox="0 0 33 35" fill="none">
                  <ellipse cx="16.1796" cy="17.7206" rx="16.1796" ry="17.0471" fill="white" />
                  <path d="M15.1429 18.4345H10V16.6283H15.1429V11.2097H16.8571V16.6283H22V18.4345H16.8571V23.8531H15.1429V18.4345Z" fill="#1C1B1F" />
                </svg>
              </button>
            </div>
          </div>

          <div className=" card-body d-flex flex-column align-items-start" style={{ cursor: "pointer" }}
            onClick={() => navigate(`/productdetails/${product._id}`)}
          >
            <div className=" card-body-div d-flex flex-column  justify-content-between ">

              <div className="sub-cat-card-rate-div  ">
                <Rating
                  className=""
                  name="simple-controlled"
                  value={parseFloat(props.rates[index])}
                  readOnly
                  style={{
                    fontSize: '19px',
                  }}

                />
              </div>

              <p className=' sub-cat-card-p1 mb-0 ' style={isOpen ? null : paragrapghstyle}>{product.brand.name && product.brand.name}</p>
              <p className=' sub-cat-card-p2 mb-0 ' style={isOpen ? null : paragrapghstyle}>{product.name}</p>
              <span className=' sub-cat-card-p3-div'>


                {product.price_before !== product.price_after ? (
                  <>
                    <div className='sub-cat-card-price-before rtl-div  '> {product.price_after} {t('curency')}</div>
                    <del className='sub-cat-card-price-after rtl-div  mx-2'> {product.price_before} {t('curency')}  </del>
                  </>
                ) : (
                  <>
                    <div className='sub-cat-card-price-before rtl-div  '>{product.price_before} {t('curency')} </div>
                  </>
                )}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SearchCard



